import React from "react";

const EndEllipsisText = ({ originalText, length }) => (
  <span>{originalText.slice(0, length)}&#8230;</span>
);
export default EndEllipsisText;
